import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';
import logo from './logo.png';
import SEO from './components/SEO';
import { generateBreadcrumbSchema } from './utils/structuredData';

export default function Privacy() {
  const breadcrumbs = [
    { name: 'Home', url: '/' },
    { name: 'Privacy Policy', url: '/privacy' }
  ];

  return (
    <div className="terms-root">
      <SEO
        title="Privacy Policy - Taealam"
        description="Learn how Taealam protects your data and privacy. Read our comprehensive privacy policy for students and teachers on our educational platform."
        keywords="privacy policy, data protection, user privacy, Taealam privacy, education platform privacy"
        canonicalUrl="/privacy"
        alternateUrls={{ en: '/privacy', ar: '/privacy-ar' }}
        lang="en"
        structuredData={generateBreadcrumbSchema(breadcrumbs)}
      />

      <Link to="/signup">
        <img src={logo} alt="Taealam Logo" className="terms-logo" />
      </Link>
      <Link to="/privacy-ar">
        <button className="terms-lang-btn">العربية</button>
      </Link>
      <div className="terms-content">
        <h1 className="terms-title">Privacy Policy</h1>
        <div className="terms-updated">Last Updated: June 22, 2025</div>
        <section>
          <h2>Introduction</h2>
          <p>This privacy policy describes how Taealam collects, stores, and uses your personal data.</p>
        </section>
        <section>
          <h2>Personal Data Collected</h2>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Grade level</li>
            <li>Subjects taught</li>
            <li>Uploaded photos and certificates</li>
            <li>Booking and chat records</li>
          </ul>
        </section>
        <section>
          <h2>Is it mandatory to provide personal data?</h2>
          <p>Yes, this data is essential to use the platform and create accounts.</p>
        </section>
        <section>
          <h2>Data Sharing</h2>
          <p>Your information is only shared internally within the platform and never externally without your permission.</p>
        </section>
        <section>
          <h2>Retention Period</h2>
          <p>Data is retained while the account is active and for up to 10 years after closure for legal purposes.</p>
        </section>
        <section>
          <h2>User Rights</h2>
          <ul>
            <li>Access your data</li>
            <li>Request corrections</li>
            <li>Delete your data</li>
            <li>Withdraw consent</li>
            <li>Object to processing</li>
          </ul>
        </section>
        <section>
          <h2>Security</h2>
          <p>We use reasonable safeguards to protect data but cannot guarantee 100% security.</p>
        </section>
        <section>
          <h2>Cookies</h2>
          <p>We use cookies to improve user experience and provide relevant content.</p>
        </section>
        <section>
          <h2>Contact</h2>
          <p>Email: <a href="mailto:privacy@taealam.bh">privacy@taealam.bh</a></p>
        </section>
      </div>
    </div>
  );
} 